import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=bac3dff8&scoped=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPage.vue?vue&type=style&index=0&id=bac3dff8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac3dff8",
  null
  
)

export default component.exports